import { CustomerTenantClient, CustomerTenantDto } from "@lib/ShiOneClient";
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import { hasAccountIdentity } from "@features/impersonation-feature/accountIdentity";
import ms from "ms";

const CustomerTenantCurrentQKey = "customer-tenant-current";

export default function useGetTenantCurrent(): UseQueryResult<
  CustomerTenantDto | null,
  Error
> {
  const { getClaimValue } = useClaims();
  const api = useApi(CustomerTenantClient);

  const id = getClaimValue("accountId") ?? null;

  const fetch = async (): Promise<CustomerTenantDto | null> => {
    const tenant = await api.getCustomerTenantCurrent();

    if (!tenant?.accounts) {
      return tenant;
    }

    return new CustomerTenantDto({
      ...tenant,
      accounts: tenant.accounts.filter((account) =>
        hasAccountIdentity(
          account.autotaskAccountId,
          account.name,
          account.axNumber,
        ),
      ),
    });
  };

  return useQuery({
    queryKey: [CustomerTenantCurrentQKey, id],
    queryFn: fetch,
    enabled: !!id,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: ms("30m"),
  });
}
